module.exports = __webpack_public_path__ + "img/banner_new_2.c3a990f7.png";